import { Controller } from "stimulus";

export default class extends Controller {
  update() {
    document.getElementById(this.element.dataset.submitId).click();
  }
}
